import {apiInfo, QT} from '../globals/config';
import {idgUrl} from '../../global/apiProxy';
import {createServiceItems, modal} from '../modules/serviceDescription';
import {formatDuration} from '../../appointment-tool/modules/serviceSelector';
import qtAnalytics from './qtAnalytics';

const $ = jQuery;

export function wpLoadService() {
    $.ajax({
        type: 'POST',
        url: menaObject.ajaxurl,
        dataType: 'html',
        data: {
            action: 'qt_get_diagnosis_info',
            service_id: QT.wpServiceId,
        },
        beforeSend: function () {
            $('#quote-tool .c-qt').addClass('loading');
        },
        success: function (response) {
            let services = JSON.parse(response);

            if (services && Array.isArray(services)) {
                const $diagnosisServiceContainer = $('.c-qt-diagnosis__services');
                $diagnosisServiceContainer.empty(); // Clear existing services if any

                // Remove duplicate services
                services = services.filter((service, index, self) =>
                    index === self.findIndex((t) => (
                        t.id === service.id
                    ))
                );

                services.forEach(service => {
                    const $serviceItem = $(`
                        <div class="c-qt-diagnosis__service text-left" data-service-id="" data-service-price="0"
	        data-service-duration="0">
                            <div>
                                <div class="c-qt-diagnosis__service-icon mb-1">
                                    <figure class="js-qt-diagnosis-service-icon"></figure>
                                    <div class="c-qt-diagnosis__service-shape c-qt-diagnosis__service-shape--mobile font-14 font-light text-center">
                                        <svg class="c-qt-diagnosis__service-shape-icon">
                                            <use xlink:href="${menaObject.sprite}#hours-red"></use>
                                        </svg>
                                        <p class="mb-0">${menaObject.labels.diagnosis.duration}</p>
                                        <p class="js-qt-diagnosis-service-duration mb-0 color-dark">1h</p>
                                    </div>
                                </div>
                                <div class="c-qt-diagnosis__service-name">
                                    <h5 class="js-qt-diagnosis-service-name mb-2"></h5>
                                    <p class="js-qt-diagnosis-service-text color-gray-600"></p>
                                    <a href="#" class="js-qt-diagnosis-service-cta button button--link2 color-dark font-bold text-uppercase font-10">${menaObject.labels.cta.read_more}</a>
                                </div>
                                <div class="c-qt-diagnosis__service-modal js-qt-diagnosis-service-modal color-dark background-gray-200">
                                    <div class="c-qt-diagnosis__service-modal-header background-blue-200 text-center">
                                        <h5 class="font-semibold mb-0">${menaObject.labels.diagnosis.services}</h5>
                                        <span class="js-ap-diagnosis-service-modal-close c-qt-diagnosis__service-modal-close"></span>
                                    </div>
                                    <div class="js-qt-diagnosis-service-modal-items c-qt-diagnosis__service-modal-items h5"></div>
                                </div>
                            </div>
                            <div class="c-qt-diagnosis__service-shape font-14 font-light text-center">
                                <svg class="c-qt-diagnosis__service-shape-icon">
                                    <use xlink:href="${menaObject.sprite}#hours-red"></use>
                                </svg>
                                <p class="mb-0">${menaObject.labels.diagnosis.duration}</p>
                                <p class="js-qt-diagnosis-service-duration mb-0 color-dark">1h</p>
                            </div>
                        </div>
                    `);

                    const $diagnosisServiceIcon = $serviceItem.find('.js-qt-diagnosis-service-icon');
                    const $diagnosisServiceName = $serviceItem.find('.js-qt-diagnosis-service-name');
                    const $diagnosisServiceText = $serviceItem.find('.js-qt-diagnosis-service-text');
                    const $diagnosisServiceDuration = $serviceItem.find('.js-qt-diagnosis-service-duration');
                    const $diagnosisServiceLink = $serviceItem.find('.js-qt-diagnosis-service-cta');
                    $diagnosisServiceIcon.append(service.icon);
                    $diagnosisServiceName.text(service.title);
                    $diagnosisServiceText.text(service.excerpt || '');
                    $diagnosisServiceLink.attr('href', service.url);

                    if (service.duration) {
                        let duration = formatDuration(parseFloat(service.duration));
                        $diagnosisServiceDuration.text(`${duration}`);
                        $serviceItem.attr('data-service-duration', service.duration);
                    }

                    /*
                    if (service.status === 'draft') {
                        $diagnosisServiceLink.hide();
                    } else {
                        $diagnosisServiceLink.show();
                    }
                    */

                    if (service.price) {
                        $serviceItem.attr('data-service-price', service.price);
                    }

                    if(service.id) {
                        $serviceItem.attr('data-service-id', service.id);
                    }

                    $diagnosisServiceContainer.append($serviceItem);
                });

                $('#quote-tool .c-qt').removeClass('loading');
                $('#quote-tool section.active').removeClass('active');
                $(`#quote-tool section[data-step-name="diagnosis"]`).addClass('active');

                services.forEach(service => createServiceItems(service.items));

                modal();
                qtAnalytics('result-start');
            }

        },
    });
}

export function loadPricing() {
    const settings = {
        async: true,
        // The proxy builds the price request body (live garage) server side.
        url: idgUrl('quote'),
        method: 'GET',
        headers: {
            Accept: 'application/json',
        },
        data: {
            vehicleId: QT.vehicleId,
            serviceId: QT.apiServiceId,
            garageId: apiInfo.garageId,
        },
    };

    $.ajax(settings).done(function (response) {
        // QT.price = String(response.data[0].price.maxPriceExclTax + labels.currency);
        console.log(response)

        // if (QT.price) {
        //     $('#quote-tool section.active').removeClass('active');
        //
        //     if ($('.js-calculation-step--price').length == 0) {
        //         $('section[data-step-name="calculation"]').find('h3').append(`
        // 			<span class="js-calculation-step--price">${QT.price}</span>
        // 		`);
        //     }
        //
        //     $(`#quote-tool section[data-step-name="calculation"]`).addClass('active');
        //
        // }
    });
}
